export default class StringUtils {
    static formatModel = (modelString) => {
        if (modelString == null) {
            return "";
        }
        return modelString.replace(/ob\.\d\d|\.\d\d/gi, '');
    }
    static formatPrice = (value) => {
        if (value == null) {
            value = "0";
        }
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
}